<template>
  <div class="container">
    <div class="main-top">
      <div class="row">
        <div class="col-lg-6 download-left">
          <p class="fs20 white">神奇印箱，完美印象</p>
          <img class="download-phone" src="../assets/img/download-phone.png">
        </div>
        <div class="col-lg-6 download-right">
          <div class="printbox-box">
            <img class="download-printbox fl" src="../assets/img/download-printbox.png">
            <div class="download-info fl">
              <img class="download-logo" src="../assets/img/download-logo.png">
              <p class="fs20 white">扫一扫，下载印箱云打印APP<br>随时随地方便打印</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PageDownload",
    props: ['isLogin'],
    data: function () {
      return {
        mobile : ''
      }
    },
    methods: {
      submit : function () {

      }
    },
    created: function () {
      console.info('page-download-init');
    }
  }
</script>

<style scoped>
  .download-logo {
    height: 50px;
  }
  .download-printbox {
    width: 160px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PageDownload.vue